export function makeFieldsData (studentData, grades = false) {
  const fields = {}
  studentData.forEach(function(student) {
    if (student.student_exam_mark.length !== 0) {
      const markField = `enroll_mark[${student.id}][exam_mark_score]`
      const examMark = grades ? student.student_exam_mark[0].exam_mark_grade : student.student_exam_mark[0].exam_mark_score

      fields[markField] = examMark
      // ============================================== //

      let theoryMark = student.student_exam_mark[0].theory_mark
      let practicalMark = student.student_exam_mark[0].practical_mark
      const isAbsent = student.student_exam_mark[0].is_absent

      if (isAbsent === 1) {
        if (theoryMark === null && !grades) theoryMark = -1
        if (practicalMark === null && !grades) practicalMark = -1
      } else if (isAbsent === 2) {
        if (theoryMark === null && !grades) theoryMark = -2
        if (practicalMark === null && !grades) practicalMark = -2
      }

      fields[`enroll_mark[${student.id}][mark]`] = student.student_exam_mark[0].mark
      fields[`enroll_mark[${student.id}][grade]`] = student.student_exam_mark[0].grade
      fields[`enroll_mark[${student.id}][theory_grade]`] = student.student_exam_mark[0].theory_grade
      fields[`enroll_mark[${student.id}][practical_grade]`] = student.student_exam_mark[0].practical_grade
      fields[`enroll_mark[${student.id}][theory_mark]`] = theoryMark
      fields[`enroll_mark[${student.id}][practical_mark]`] = practicalMark
    }
  })

  return fields
}
